"use strict";
var inputs = document.querySelectorAll("form input");
inputs.forEach(function(input) {
    var inputName = input.name;
    var capitalized = inputName.slice(0, 1).toUpperCase() + inputName.slice(1);
    var label = document.createElement("label");
    label.classList.add("field-label");
    label.htmlFor = input.id;
    input.placeholder = capitalized;
    input.textContent = inputName;
    input.parentElement.append(label);
});

//# sourceMappingURL=index.ec2e038f.js.map
